module.exports = __webpack_public_path__ + "img/Dual Ring-1.3s-250px.67a5dac6.gif";